<template>
    <Head :title="title" />

    <div class="min-h-screen bg-white">
        <!-- Top bar with logo + actions -->
        <header class="border-b border-gray-200 bg-white">
            <div class="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex items-center justify-between">
                <a :href="appUrl('/')" class="flex items-center" aria-label="RentRisk home">
                    <jet-authentication-card-logo-colored class="h-10 w-auto" />
                </a>
                <button
                    type="button"
                    @click="print"
                    class="hidden sm:inline-flex items-center px-3 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#2A375E] no-print"
                >
                    <font-awesome-icon :icon="faPrint" class="mr-2 h-4 w-4" />
                    Print
                </button>
            </div>
        </header>

        <!-- Document body -->
        <main class="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12">
            <div ref="documentBody">
                <h1 class="text-2xl sm:text-3xl font-bold text-gray-900 mb-2">{{ title }}</h1>
                <p v-if="version" class="text-sm text-gray-500 mb-8 font-mono">Version {{ version }}</p>
                <p v-else-if="lastUpdated" class="text-sm text-gray-500 mb-8">Last updated {{ lastUpdated }}</p>

                <slot />
            </div>
        </main>

        <!-- Simple footer -->
        <footer class="border-t border-gray-200 bg-gray-50 mt-12 no-print">
            <div class="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-6 text-sm text-gray-500 flex flex-col sm:flex-row sm:justify-between gap-2">
                <span>&copy; {{ new Date().getFullYear() }} RentRisk LLC. All rights reserved.</span>
                <span class="space-x-4">
                    <a :href="appUrl('/terms-of-service')" class="hover:text-gray-700">Terms of Service</a>
                    <a :href="appUrl('/privacy-policy')" class="hover:text-gray-700">Privacy Policy</a>
                </span>
            </div>
        </footer>
    </div>
</template>

<script>
import { Head } from '@inertiajs/vue3';
import JetAuthenticationCardLogoColored from '@/Jetstream/AuthenticationCardLogoColored.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faPrint } from '@fortawesome/pro-solid-svg-icons';

export default {
    name: 'LegalDocumentLayout',
    components: {
        Head,
        JetAuthenticationCardLogoColored,
        FontAwesomeIcon,
    },
    props: {
        title: { type: String, required: true },
        version: { type: String, default: null },
        lastUpdated: { type: String, default: null },
    },
    data() {
        return { faPrint };
    },
    methods: {
        print() {
            window.print();
        },
    },
};
</script>

<style>
@media print {
    .no-print { display: none !important; }
    body { background: white !important; }
}
</style>
